function normalizePermissions(value) {
  const source = Array.isArray(value) ? value : Array.isArray(value?.permissions) ? value.permissions : [];

  return [...new Set(source.filter((item) => typeof item === 'string' && item.trim() !== ''))];
}

export function getUserPermissions(user) {
  return normalizePermissions(user);
}

export function hasPermission(value, permission) {
  if (!permission) {
    return false;
  }

  return normalizePermissions(value).includes(permission);
}

export function hasAnyPermission(value, permissions) {
  const required = Array.isArray(permissions) ? permissions : [];
  if (required.length === 0) {
    return false;
  }

  const available = normalizePermissions(value);
  return required.some((permission) => available.includes(permission));
}

export function filterMenuItemsByPermissions(items, permissions) {
  return items
    .filter((item) => {
      if (item.requiresPermission && !hasPermission(permissions, item.requiresPermission)) {
        return false;
      }

      if (item.requiresAnyPermission && !hasAnyPermission(permissions, item.requiresAnyPermission)) {
        return false;
      }

      return true;
    })
    .map((item) => {
      if (!Array.isArray(item.children)) {
        return item;
      }

      return {
        ...item,
        children: filterMenuItemsByPermissions(item.children, permissions),
      };
    })
    .filter((item) => !Array.isArray(item.children) || item.children.length > 0);
}

export function resolvePermissionRouteAccess({ isLoading, permissions, requiredPermission, requiredAnyPermission }) {
  if (isLoading) {
    return 'loading';
  }

  if (requiredPermission && !hasPermission(permissions, requiredPermission)) {
    return 'redirect';
  }

  if (requiredAnyPermission && !hasAnyPermission(permissions, requiredAnyPermission)) {
    return 'redirect';
  }

  return 'allow';
}
